export default `
mutation sendAuthCode(
	$input: SendAuthCodeInput!
) {
	sendAuthCode(
	input: $input
	) 
}
`;
